import dayjs from 'dayjs';

function isNewUser(user, config) {
  return dayjs(user.attributes.created_at).isAfter(dayjs(config.payoneerLaunchDate));
}

function isPayoneerPending(user) {
  return user.attributes.payoneer_status === 'PENDING_REGISTRATION';
}

export default async function payoneer({ app, store, $config }) {
  const { user } = app.$auth;
  if (user) {
    if (!user.attributes?.payoneer_status
      && !!user.attributes?.application_done
      && !isNewUser(user, $config)
      && !isPayoneerPending(user)
      && user.attributes?.welcomed) {
      store.commit('ui/setPayoneerNotification', true);
    }
  }
}
